/** V2 removes Forge approval metadata; the Editor's catalog projection is unchanged. */
export const SUPPORTED_AUTOMATION_CAPABILITY_SCHEMA_VERSIONS: readonly number[] = [1, 2];

export type CapabilityField = {
  id: string;
  label: string;
  visibility: 'public' | 'internal' | 'read_only' | 'deprecated';
  classification: 'documented_public' | 'derived_read_only' | 'deprecated' | 'internal';
  deprecated: boolean;
  required: boolean;
  default: unknown;
  schema: Record<string, unknown>;
  modes: string[];
  summary: string;
  non_effect: string;
};

export type CapabilityStep = {
  id: string;
  label: string;
  summary: string;
  behavior: string;
  output_behavior: string;
  validation_behavior: string;
  review_behavior: string;
  retry_behavior: string;
  side_effects: string;
  emitted_evidence: string;
  fields: CapabilityField[];
};

export type AutomationCapabilityCatalog = {
  schema_version: number;
  /** Informational content revision; additive changes do not require a UI deploy. */
  catalog_revision: string;
  shared_concepts: Array<{ id: string; label: string; summary: string }>;
  creation_presets: Array<{ id: string; label: string; summary: string }>;
  steps: CapabilityStep[];
};
